import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "about-us",
  class: "relative h-full align-middle w-full px-10 mx-auto xl:px-5 overflow-hidden"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-1/4 h-1/3 md:h-1/2 bg-dots bg-no-repeat bg-cover right-0 md:-right-4 w-10 lg:w-40 md:w-30 sm:w-20 opacity-50" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "absolute top-1/4 h-1/3 md:h-1/2 bg-dots bg-no-repeat bg-cover left-0 md:-left-4 w-10 lg:w-40 md:w-30 sm:w-20 opacity-50" }, null, -1)
const _hoisted_4 = { class: "flex flex-col py-10 md:space-y-0 md:space-x-5 md:flex-row w-10/12 md:w-2/3 mx-auto xs:my-auto" }
const _hoisted_5 = { class: "py-3 text-2xl md:text-5xl md:rtl:text-4xl text-red-600 rtl:font-cairo font-oswald font-semibold" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "splide__arrows" }, [
  /*#__PURE__*/_createElementVNode("button", {
    class: "splide__arrow splide__arrow--prev bg-transparent right-0 absolute -mr-10 text-red-500",
    style: {"color":"red"}
  }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: "",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "{2}",
        d: "M13 5l7   7-7 7M5 5l7 7-7 7"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("button", { class: "splide__arrow splide__arrow--next bg-transparent text-red-500 left-0 absolute -ml-10" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      className: " bg-red-500",
      fill: "none",
      viewBox: "0 0 24 24",
      stroke: "currentColor"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "{2}",
        d: "M13 5l7   7-7 7M5 5l7 7-7 7"
      })
    ])
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SplideSlide = _resolveComponent("SplideSlide")!
  const _component_Splide = _resolveComponent("Splide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('about.title')), 1),
        _createElementVNode("p", {
          class: "py-3 text-xl rtl:text-base md:text-2xl md:rtl:text-xl rtl:font-cairo font-oswald font-light",
          innerHTML: _ctx.$t('about.content')
        }, null, 8, _hoisted_6),
        _createVNode(_component_Splide, {
          class: "clients_slider py-10",
          options: $setup.options
        }, {
          "before-track": _withCtx(() => []),
          "after-track": _withCtx(() => [
            _hoisted_8
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.clients, (client) => {
              return (_openBlock(), _createBlock(_component_SplideSlide, {
                key: client,
                class: "flex flex-col my-auto items-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "max-h-10 md:max-h-14",
                    src: require(`../../public/img/clients/${client.image}`),
                    alt: "jump sa client"
                  }, null, 8, _hoisted_7)
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["options"])
      ])
    ])
  ]))
}